import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { FormikValues } from 'formik';
import Entities from './Entities';
import { useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import MultiSelectDropdown from '../../../components/formInputs/MultiSelectDropdown';

const CustomArrowIcon = ({ onClick }: { onClick: () => void }) => (
  <svg className="MuiSelect-iconCustom" height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" onClick={onClick}>
    <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
  </svg>
);


interface IProps {
  formik: FormikValues;
  // handleRoleChange: (event: SelectChangeEvent<string[] | number[]>, formik: any) => void;
  handleResponsibilityChange: (event: SelectChangeEvent<string[] | number[]>, formik: any) => void;
  rolesData: {
    id: number;
    text: string;
    value: string;
  }[];
  // selectedRoles: number[];
  // selectedRolesName: string[];
  selectedResponsibilities: number[];
  selectedResponsibilitiesName: string[];
}
const StepInputs = ({
  formik,
  rolesData,
  // handleRoleChange,
  // selectedRoles,
  // selectedRolesName,
  handleResponsibilityChange,
  selectedResponsibilities,
  selectedResponsibilitiesName
}: IProps) => {
  const { t } = useTranslation();
  // const [openRoles, setOpenRoles] = useState(false);
  const [openResponsibilities, setOpenResponsibilities] = useState(false);

  return (
    <div className="step-wrapper">
      <div className="inputs_group">
        <FieldWrapper
          title={t('stepNameEN')}
          inputName={`name[en]`}
          inputPlaceholder={`${t('ex')} ${t('uploadingDocuments')}`}
          inputError={formik?.errors?.name?.en as string}
          inputTouched={formik?.touched?.name?.en as boolean}
          input
          customPadding
        />
        <FieldWrapper
          title={t('stepNameAR')}
          inputName={`name[ar]`}
          inputPlaceholder={`${t('ex')} ${t('uploadingDocuments')}`}
          inputError={formik?.errors?.name?.ar as string}
          inputTouched={formik?.touched?.name?.ar as boolean}
          input
          customPadding
        />
        <FieldWrapper
          title={t('order')}
          inputName={`order`}
          inputPlaceholder={`${t('ex')} 1`}
          inputError={formik?.errors?.order as string}
          inputTouched={formik?.touched?.order as boolean}
          input
          customPadding
          type="number"
        />
      </div>
      <div className="inputs_group">

        {/* If We Need To Return Roles Back Uncomment This Code */}
        {/* <MultiSelectDropdown
          label={t('roles')}
          name="roles"
          value={selectedRoles}
          onChange={(event: SelectChangeEvent<string[]>) => handleRoleChange(event, formik)}
          options={rolesData || []}
          selectedLabels={selectedRolesName}
          error={formik.errors.roles}
          touched={formik.touched.roles}
          placeholder={t('select-roles')}
          customIcon={<CustomArrowIcon onClick={() => setOpenRoles(!openRoles)} />}
          open={openRoles}
          setOpen={setOpenRoles}
        /> */}

        <MultiSelectDropdown
          label={t('responsibilities')}
          name="responsibilities"
          value={selectedResponsibilities}
          onChange={(event: SelectChangeEvent<string[]>) => handleResponsibilityChange(event, formik)}
          options={rolesData || []}
          selectedLabels={selectedResponsibilitiesName}
          error={formik.errors.responsibilities}
          touched={formik.touched.responsibilities}
          placeholder={t('select_responsibilities')}
          customIcon={<CustomArrowIcon onClick={() => setOpenResponsibilities(!openResponsibilities)} />}
          open={openResponsibilities}
          setOpen={setOpenResponsibilities}
        />
        <FieldWrapper noPadding />
      </div>
      <div className="inputs_group">
        <FieldWrapper
          title={t('messageEn')}
          inputName={`message[en]`}
          inputPlaceholder={t('messageEn')}
          inputError={formik?.errors?.message?.en}
          inputTouched={formik?.touched?.message?.en}
          textArea
          maxLength={300}
          value={formik?.values?.message?.en}
          showMaxLengthHint
        />
        <FieldWrapper
          title={t('messageAr')}
          inputName={`message[ar]`}
          inputPlaceholder={t('messageAr')}
          inputError={formik?.errors.message?.ar}
          inputTouched={formik?.touched?.message?.ar}
          textArea
          maxLength={300}
          value={formik?.values?.message?.ar}
          showMaxLengthHint
        />
      </div>
      <div className="inputs_group mt-2rem">
        <FieldWrapper title={t('auto_generate_documents')} customClass="roles-form-checkbox custom-header px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`auto_generate_documents`}
                type="checkbox"
                checked={formik.values.auto_generate_documents}
                onChange={() => {
                  formik.setFieldValue('auto_generate_documents', !formik.values.auto_generate_documents);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
        <FieldWrapper title={t('customer_responsible')} customClass="roles-form-checkbox custom-header  px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`customer_responsible`}
                type="checkbox"
                checked={formik.values.customer_responsible}
                onChange={() => {
                  formik.setFieldValue('customer_responsible', !formik.values.customer_responsible);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
      </div>
      <div className="inputs_group">
        <FieldWrapper title={t('visible_to_customer')} customClass="roles-form-checkbox custom-header px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`visible_to_customer`}
                type="checkbox"
                checked={formik.values.visible_to_customer}
                onChange={() => {
                  formik.setFieldValue('visible_to_customer', !formik.values.visible_to_customer);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
        <FieldWrapper title={t('online_order_step')} customClass="roles-form-checkbox custom-header  px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`online_order_step`}
                type="checkbox"
                checked={formik.values.online_order_step}
                onChange={() => {
                  formik.setFieldValue('online_order_step', !formik.values.online_order_step);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
      </div>
      <div className="inputs_group">
        <FieldWrapper title={t('offline_order_step')} customClass="roles-form-checkbox custom-header mb-2rem px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`offline_order_step`}
                type="checkbox"
                checked={formik.values.offline_order_step}
                onChange={() => {
                  formik.setFieldValue('offline_order_step', !formik.values.offline_order_step);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
        <FieldWrapper title={t('auto_submitted')} customClass="roles-form-checkbox custom-header mb-2rem px-1rem">
          <div className="checkboxes_wrapper order_steps_checkbox">
            <label className="pointer">
              <input
                id={`auto_submitted`}
                type="checkbox"
                checked={formik.values.auto_submitted}
                onChange={() => {
                  formik.setFieldValue('auto_submitted', !formik.values.auto_submitted);
                }}
              />
            </label>
          </div>
        </FieldWrapper>
      </div>
      <Entities formik={formik} />
    </div>
  );
};

export default StepInputs;
